var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-textarea',{attrs:{"solo":"","label":"Type your request message here and registration will change it"},model:{value:(_vm.request.message),callback:function ($$v) {_vm.$set(_vm.request, "message", $$v)},expression:"request.message"}}),_c('v-btn',{staticClass:"primary",attrs:{"onclick":"sendRequest"}},[_vm._v("Apply for Request")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }